import { useState } from 'react'
import { useMyMedias } from '@/hooks/queries'
import { MyMedia } from '@/components/MyMedia'
import { AccountPage } from './account/AccountPage'
import { SkeletonLine } from '@/components/ui/Skeleton'

/** `/my/media` — the cover art library. */
export function MyMediaPage() {
  const { data: medias = [], isPending } = useMyMedias()
  const [uploading, setUploading] = useState(false)
  const tags = new Set(medias.flatMap((media) => media.tags ?? []))

  return (
    <AccountPage
      title="My Media"
      meta={
        isPending ? (
          <SkeletonLine width="14em" />
        ) : (
          `${medias.length} ${medias.length === 1 ? 'image' : 'images'}${
            tags.size > 0 ? ` · ${tags.size} ${tags.size === 1 ? 'tag' : 'tags'}` : ''
          }`
        )
      }
      action={
        // Uploading is what this page is for, so it sits where New giveaway
        // does on My Giveaways rather than only at the end of the grid.
        uploading || medias.length === 0 ? null : (
          <button
            type="button"
            className="account-primary btn-sheen"
            onClick={() => setUploading(true)}
          >
            <svg viewBox="0 0 16 16" aria-hidden="true" className="account-primary-glyph">
              <path d="M8 3.2v9.6M3.2 8h9.6" />
            </svg>
            Upload image
          </button>
        )
      }
    >
      <MyMedia uploading={uploading} onUploadingChange={setUploading} />
    </AccountPage>
  )
}
